/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const RegisterPageMeta = () => {
  const title = "Registrierung zur Servicewelt | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="Registrieren Sie sich jetzt in unserer Servicewelt und erhalten Sie unser
      Rundum-Sorglos-Paket. Einfach, schnell, günstig und immer professionell beraten. Jetzt registrieren!"
      />
      <meta name="keywords" content="Legalbird, Registrierung, registrieren, Servicewelt, Kundenbereich" />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Registrieren Sie sich jetzt in unserer Servicewelt und erhalten Sie unser
      Rundum-Sorglos-Paket. Einfach, schnell, günstig und immer professionell beraten. Jetzt registrieren!"
      />
    </Helmet>
  );
};

export default RegisterPageMeta;
